import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';

interface IComponentLacunasAlternativas {
    codigo: number;
    alternativa: string;
    correct: boolean;
}

class ComponentLacunasAlternativas extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    alternativa: string = '';

    @jsonProperty(Boolean)
    correct: boolean = false;

    fromJSON(json: IComponentLacunasAlternativas, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.alternativa = json.alternativa;
        this.correct = json.correct;
        return this;
    }
}

export default ComponentLacunasAlternativas;
